<template lang="pug">
	section
		p.mb-5
			|  Many 529 plans offer gifting platforms to allow friends and family to contribute.
		section.radio-wrap
			.radio
				sfc-radio(v-model="csgifting" :radio-value="`yes`" label="Yes" @click="next('Yes')" name="yes")
		section.radio-wrap
			.radio
				sfc-radio(v-model="csgifting" :radio-value="`no`" label="No" @click="next('No')" name="no")
		.continue-button
			sfc-button.mr-4(:blue="false" :backArrow="true" @click="back()")
</template>

<script>
import SfcRadio from '@/common/components/inputs/v2/radio'
import SfcButton from '@/common/components/sfc-button'
import SfcTrackingService from "@/lib/sfc-tracking-service"

export default {

	components:{
		SfcButton,
		SfcRadio
	},

	props: {
	},

	data() {
		return {
			errors: {
			},
			csgifting: undefined,
			progressLength: 0
		}
	},

	methods: {
		next(value){
			this.$store.commit('updateCurrentCsgifting', value)

			SfcTrackingService.trackAnalyticsAction("Savings Center Onboarding", "Gifting - next", value, 0)

			this.$emit('next', this.progressLength, "How old is your child?", "sfc-how-old-is-your-child")
		},
		back(){
			this.$emit('next', 0, "Where are you in your college savings journey?", "sfc-college-savings-journey")
		},
	}

}
</script>
